import React, { useEffect, useRef, useState } from "react";
import Card from "../../../elements/Card";
import TextEditor from "../../../elements/TextEditor";
import { useParams } from "react-router-dom";
import useClickOutside from "../../../../hooks/useClickOutside";
import { TiptapContent } from "../../../elements/tiptap-editor/EditorComponent";
import { lngDetect } from "../../../../helpers/lngDetect";
import Image from "../../../elements/Image";
import DeleteModal from "../../../common/DeleteModal";
import { useTranslation } from "react-i18next";

const ReadOnly = ({ data }) => {
  const { t } = useTranslation();
  return (
    <Card
      title={t("Summary")}
      bodyClass={"space-y-6"}
      className={" py-4 md:py-8 px-3 md:px-6"}
    >
      {data?.overView?.map((over_view, i) => (
        <div key={over_view?._id}>
          {over_view?.type === "text" && (
            <TiptapContent
              data={lngDetect(over_view?.content)}
              className={"line-clamp-5"}
            />
          )}
          {over_view?.type === "image" && over_view?.file?.url && (
            <Image
              src={over_view?.file?.url}
              effect={"fade"}
              alt={over_view?.file?.url}
            />
          )}
          {over_view?.type === "link" && (
            <a rel="noreferrer" target="_blank" href={over_view?.url || "#"}>
              {over_view?.url}
            </a>
          )}
        </div>
      ))}
    </Card>
  );
};

const Summary = ({
  values = {},
  handleChange = () => {},
  formValidate = () => {},
  setFieldsValue = () => {},
  errors,
  data,
}) => {
  const { t } = useTranslation();
  const divRef = useRef(null);
  const [showDeleteModal, setShowDeleteModal] = useState({
    data: null,
    isOpen: false,
  });
  const { eventId } = useParams();
  const [readOnly, setReadOnly] = useState(false);

  useClickOutside(divRef, () => {
    if (eventId && !showDeleteModal?.isOpen) {
      setReadOnly(true);
    } else {
      setReadOnly(false);
    }
  });

  useEffect(() => {
    if (eventId) {
      setReadOnly(true);
    }
  }, [eventId]);

  return (
    <div
      ref={divRef}
      onClick={() => {
        if (eventId) {
          setReadOnly(false);
        }
      }}
    >
      {readOnly ? (
        <ReadOnly data={values} />
      ) : (
        <Card
          title={t("Summary")}
          bodyClass={"space-y-6"}
          className={"py-4 md:py-8 px-3 md:px-6"}
        >
          <TextEditor
            value={values?.overView}
            onRemove={(val) => {
              setShowDeleteModal({ isOpen: true, data: val });
            }}
            onChange={(val) => {
              handleChange({ target: { name: "overView", value: val } });
            }}
            {...formValidate(errors, "overView")}
            className={"p-0 md:p-5"}
          />
        </Card>
      )}
      <DeleteModal
        open={showDeleteModal?.isOpen}
        onClose={() => {
          setShowDeleteModal({ data: null, isOpen: false });
        }}
        deleteHandler={(e) => {
          handleChange({
            target: {
              name: "overView",
              value: values?.overView?.filter(
                (item) => item?.id !== showDeleteModal?.data?.id
              ),
            },
          });
          setShowDeleteModal({ data: null, isOpen: false });
        }}
        customMessage={t("Are you sure you want to delete this file?")}
      />
    </div>
  );
};

export default Summary;
